import React from 'react';
import { motion } from 'framer-motion';
const WHATSAPP_LINK = 'https://wa.me/573054520211?text=Hola%20vengo%20desde%20la%20web%20y%20quiero%20reservar%20una%20cita';
export function FinalCTA() {
  return <section className="py-12 md:py-24 bg-[#0F0F0F] relative border-t border-brand-card" data-id="element-26">
      <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-32 h-[1px] bg-brand-gold" data-id="element-27"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-28">
        <motion.h2 initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-5xl lg:text-6xl font-playfair text-white mb-4 md:mb-6 leading-tight" data-id="element-29">
          Tu próximo corte empieza aquí
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-lg md:text-xl text-brand-gray mb-8 md:mb-12 max-w-2xl mx-auto" data-id="element-30">
          No esperes más. Reserva ahora y vive la experiencia Le Barber Club
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-31">
          <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-3 btn-gold px-10 py-5 text-xl" data-id="element-32">
            <span className="text-2xl" data-id="element-33">📲</span> Reservar por WhatsApp ahora
          </a>
        </motion.div>
      </div>
    </section>;
}